/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

export const defaultAutoRetry = (autoRetry: boolean | null | undefined): boolean => autoRetry === true;
